import { Alert } from "Components/_Shared/Alert";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

export const ModelingAlert: FC = () => {
  const { t } = useResource();

  return (
    <Alert
      variant={"error"}
      title={t(Resources.AnalysisDetail.Modeling.ChangesMade)}
      text={t(Resources.AnalysisDetail.Modeling.Overdistribution)}
    />
  );
};
